import { Injectable } from '@angular/core';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Computed, StateRepository } from '@angular-ru/ngxs/decorators';
import { State } from '@ngxs/store';
import { Comment, CommentService, RequestOptions } from '@portals/api';

import { finalize, mergeMap, tap } from 'rxjs/operators';

interface StateModel {
	isLoading: boolean;
	data: Comment[];
	selected: Comment;
}

@StateRepository()
@State<StateModel>({
	name: 'comments',
})
@Injectable()
export class CommentsState extends NgxsDataRepository<StateModel> {
	@Computed()
	get isLoading() {
		return this.snapshot.isLoading;
	}

	@Computed()
	get hasData() {
		return !!this.snapshot.data;
	}

	@Computed()
	get data() {
		return this.snapshot.data;
	}

	@Computed()
	get item() {
		return this.snapshot.selected;
	}

	constructor(private commentService: CommentService) {
		super();
	}

	load(options?: RequestOptions) {
		this.patchState({ isLoading: true });

		return this.commentService.find(options).pipe(
			tap(({ data }) => {
				this.patchState({ data });
			}),
			finalize(() => {
				this.patchState({ isLoading: false });
			})
		);
	}

	create(payload: Omit<Comment, 'id'>, options?: RequestOptions) {
		this.patchState({ isLoading: true });

		return this.commentService.create(payload, options);
	}
}
